export default __webpack_public_path__ + "static/media/ic_company_b.6610fdef.svg";